"use strict";
exports.__esModule = true;
exports.create = void 0;
var tailwind_1 = require("./tailwind");
exports.create = tailwind_1["default"];
// eslint-disable-next-line @typescript-eslint/no-var-requires
var tailwind = tailwind_1["default"](require("../tw-rn-styles.json"));
exports["default"] = tailwind;
